import React, { PropTypes } from 'react';
import { equals, call, ifElse } from 'ramda';
import GenericRadioButtons from './generic-radio-buttons';

const AccomTable = props => {
  const {
    dispatchedUpdateProps,
    oneOrMultiProperties,
  } = props;

  const onePropertyOrMultiRadios = [
    {
      label: 'We own/manage one property.',
      value: 'one-prop',
    },
    {
      label: 'We own/manage multiple properties.',
      value: 'multi-prop',
    },
  ];

  const numOfPropertiesRadios = [
    {
      label: '2 - 25',
    },
    {
      label: '26 - 50',
    },
    {
      label: '51+',
    },
  ];

  return (
    <div>
      <GenericRadioButtons
        radiosMap={onePropertyOrMultiRadios}
        name={"oneOrMultiProp"}
        defaultChecked={oneOrMultiProperties}
        handleOnClick={selected => dispatchedUpdateProps({ oneOrMultiProperties: selected, numOfProperties: '' })}
      />
      {
        call(ifElse(
          equals('multi-prop'),
            () => (
              <GenericRadioButtons
                title={'How many properties do you have?'}
                radiosMap={numOfPropertiesRadios}
                name={"numOfProperties"}
                handleOnClick={selected => dispatchedUpdateProps({ numOfProperties: selected })}
              />
            ),
          () => <span/>
        ), oneOrMultiProperties)
      }
    </div>
  );
};

AccomTable.propTypes = {
  dispatchedUpdateProps: PropTypes.func,
  oneOrMultiProperties: PropTypes.string,
};

export default AccomTable;



// WEBPACK FOOTER //
// ./src/app/components/signup/supplier/accom-table.jsx